(() => {
  const save = document.querySelector('[data-dlm-save-article]');
  const print = document.querySelector('[data-dlm-print]');
  const copy = document.querySelector('[data-dlm-copy-link]');
  const cook = document.querySelector('[data-dlm-cook-mode]');
  if(!save && !print && !copy && !cook) return;

  const key='dlm_saved_recipes';
  const read=()=>{try{return JSON.parse(localStorage.getItem(key)||'[]')}catch(e){return[]}};
  const write=(v)=>localStorage.setItem(key,JSON.stringify(v.slice(0,50)));

  const update=()=>{
    if(!save) return;
    const id=String(save.dataset.articleId||'');
    const active=read().some(x=>String(x.id)===id);
    save.textContent=active?'Gemerkt':'Merken';
    save.classList.toggle('is-active',active);
    save.setAttribute('aria-pressed',active?'true':'false');
  };

  if(save){
    save.addEventListener('click',()=>{
      const id=String(save.dataset.articleId||'');
      let items=read();
      const exists=items.some(x=>String(x.id)===id);
      if(exists) items=items.filter(x=>String(x.id)!==id);
      else items.unshift({
        id,
        title:save.dataset.articleTitle||document.title,
        url:save.dataset.articleUrl||location.pathname,
        image:save.dataset.articleImage||''
      });
      write(items);update();
    });
    update();

    try{
      const id=String(save.dataset.articleId||'');
      let recent=JSON.parse(localStorage.getItem('dlm_recent_recipes')||'[]');
      recent=recent.filter(x=>String(x.id)!==id);
      recent.unshift({id,title:save.dataset.articleTitle||document.title,url:save.dataset.articleUrl||location.pathname,image:save.dataset.articleImage||''});
      localStorage.setItem('dlm_recent_recipes',JSON.stringify(recent.slice(0,12)));
    }catch(e){}
  }

  if(print) print.addEventListener('click',()=>window.print());

  const content=document.querySelector('.article-template__content');
  const tools=document.querySelector('.dlm-article-tools');

  if(content && tools){
    const headings=[...content.querySelectorAll('h2,h3')];
    const findHeading=(pattern)=>headings.find(h=>pattern.test((h.textContent||'').trim()));
    const ingredientHeading=findHeading(/zutaten/i);
    const methodHeading=findHeading(/zubereitung|anleitung|so geht/i);
    const addJump=(label,target)=>{
      if(!target) return;
      if(!target.id) target.id='dlm-'+label.toLowerCase().replace(/[^a-z0-9]+/g,'-');
      const b=document.createElement('button');
      b.type='button'; b.className='button button--secondary dlm-article-tool dlm-article-tool--jump';
      b.textContent=label;
      b.addEventListener('click',()=>target.scrollIntoView({behavior:'smooth',block:'start'}));
      tools.insertBefore(b,tools.firstChild);
    };
    addJump('Zur Zubereitung',methodHeading);
    addJump('Zu den Zutaten',ingredientHeading);

    if(ingredientHeading){
      let list=ingredientHeading.nextElementSibling;
      while(list && !/^(UL|OL)$/.test(list.tagName) && !/^H[23]$/.test(list.tagName)) list=list.nextElementSibling;
      if(list && /^(UL|OL)$/.test(list.tagName)){
        list.classList.add('dlm-checklist');
        [...list.children].forEach((li,i)=>{
          if(li.querySelector('input[type="checkbox"]')) return;
          const label=document.createElement('label');
          label.className='dlm-checklist__item';
          const cb=document.createElement('input');
          cb.type='checkbox'; cb.setAttribute('aria-label','Zutat abhaken');
          const span=document.createElement('span');
          while(li.firstChild) span.appendChild(li.firstChild);
          label.append(cb,span);li.appendChild(label);
        });
      }
    }
  }

  let wakeLock=null;
  const releaseWake=async()=>{
    if(wakeLock){try{await wakeLock.release();}catch(e){} wakeLock=null;}
    if(cook){cook.textContent='Kochmodus';cook.classList.remove('is-active');cook.setAttribute('aria-pressed','false');}
  };
  const requestWake=async()=>{
    if(!cook) return;
    if(!('wakeLock' in navigator)){
      cook.textContent='Bildschirm wach halten nicht unterstützt';
      setTimeout(()=>cook.textContent='Kochmodus',2200);
      return;
    }
    try{
      wakeLock=await navigator.wakeLock.request('screen');
      cook.textContent='Kochmodus aktiv ✓';
      cook.classList.add('is-active');
      cook.setAttribute('aria-pressed','true');
      wakeLock.addEventListener('release',()=>{wakeLock=null;if(cook){cook.textContent='Kochmodus';cook.classList.remove('is-active');cook.setAttribute('aria-pressed','false');}});
    }catch(e){
      cook.textContent='Kochmodus nicht verfügbar';
      setTimeout(()=>cook.textContent='Kochmodus',1800);
    }
  };
  if(cook) cook.addEventListener('click',()=>wakeLock?releaseWake():requestWake());
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible' && cook?.getAttribute('aria-pressed')==='true' && !wakeLock) requestWake();});

  if(copy){
    copy.addEventListener('click',async()=>{
      const url=location.href;
      try{
        await navigator.clipboard.writeText(url);
        const old=copy.textContent;
        copy.textContent='Link kopiert ✓';
        setTimeout(()=>copy.textContent=old,1800);
      }catch(e){
        window.prompt('Link kopieren:',url);
      }
    });
  }
})();